module.exports = __webpack_public_path__ + "img/GUM.92fda27f.svg";